import React, { FC } from 'react';

import styles from './Button.module.scss';
import { HippoComponentProps } from '../index';
import classNames from 'classnames';
import Icon from '../Icon/Icon';

export interface Props extends HippoComponentProps {
  text: string;
  size: 'small' | 'regular' | 'large' | 'extra-large';
  type: 'accent' | 'primary' | 'primary-inverse' | 'location' | 'negative';
  style: 'filled' | 'tonal' | 'outlined' | 'outlined-tonal';
  disabled?: boolean;
  icon?: string;
  onClick?: () => void;
}

const Button: FC<Props> = ({
  text,
  size,
  type,
  style,
  icon,
  dataQA,
  className,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      data-qa={dataQA}
      className={classNames(
        styles.container,
        className,
        styles[size],
        styles[type],
        styles[`${type}-${style}`],
        {
          [styles.disabled]: disabled,
        }
      )}
      onClick={onClick}
    >
      {icon && (
        <div className={styles.iconFrame}>
          <Icon
            dataQA="icon"
            name={icon}
            size={24}
            className={classNames({ [styles.smallIcon]: size === 'small' })}
          />
        </div>
      )}
      <div>{text}</div>
    </button>
  );
};

export default Button;
